import _ from 'lodash';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SimpleChanges, ChangeDetectorRef, AfterViewInit, Inject } from '@angular/core';
import { CampaignService } from '../../services/campaign.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { PartySignUpPresetOptionSchema } from '../../structure/party-signup';
import { ImageService } from 'app/core/services/image.service';
import { Subject } from 'rxjs';
import { takeUntil, filter, map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

import * as DialogActions from 'app/dialog/features/dialog.actions';
import { select, Store } from '@ngrx/store';
import { selectCampaignSelected } from '../../features/campaign.selectors';
import { newAddCampaignPresetOption, newCreateCampaignPresetOption, newUpdateCampaignPresetOption } from '../../features/campaign.actions';
import { CampaignFormService } from '../../services/campaign-form.service';
import { ChooseImageModalService } from 'app/core/services/choose-image-modal.service';
import { ToastService } from 'app/toast/services/toast.service';
import { MdbDropEvent, moveItemsInContainer } from 'mdb-angular-drag-and-drop';
import { CampaignOptionFormService } from 'app/campaign/services/campaign-option-form.service';
import { PARTY_SIGNUP_ACCORDION_SETTINGS_TOKEN, PARTY_SIGNUP_ACCORDION_SETTINGS_PROVIDER, PARTY_SIGNUP_SETTINGS_TYPE } from 'app/campaign/tokens';
import { AccordionService } from 'app/campaign/services';
import { AMOUNT_LIMIT } from 'app/virtual-event/virtual-event.enums';

@Component({
  selector: 'app-campaign-party-signup-option',
  templateUrl: './campaign-party-signup-option.component.html',
  styleUrls: ['./campaign-party-signup-option.component.scss'],
  providers: [
    PARTY_SIGNUP_ACCORDION_SETTINGS_PROVIDER,
    {
      provide: PARTY_SIGNUP_SETTINGS_TYPE,
      useValue: 'presetOption',
    },
  ]
})
export class CampaignPartySignUpOptionComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() formGroupCampaignTypeData: any = null;
  @Input() selected: any = null;
  @Input() sold: any = 0;

  @Output() onChangeData: EventEmitter<any> = new EventEmitter();

  public AMOUNT_LIMIT = AMOUNT_LIMIT;
  
  public campaign$ = this.store.pipe(
    select(selectCampaignSelected)
  );
  public campaign = null;

  public option: UntypedFormGroup = null;

  public optionImages: any = [];
  public imagesQueue = [];
  public chooseImageModalShow = false;

  public value: any = null;

  public quillOptions = {
    showToolbarList: false,
    size: 'sm'
  }

  public partySignupStartTimeOptions: any = {
    dateFormat: 'mm/dd/yyyy'
  }
  public partySignupEndTimeOptions: any = {
    dateFormat: 'mm/dd/yyyy'
  }

  public hostNameEmpty = true;
  public hostEmailEmpty = true;
  public hostIsValid = false;
  
  public takeUntilSubject: Subject<any> = new Subject();

  public isTolalInventoryValid = true
  public inventoryValue = null
  public popoverText = "<span>Switch ON to combine other tickets options with this ticket option and sell as a package. Eg. a VIP ticket package could include an event ticket, two raffle tickets and a drink ticket.</span><a class='blue-text mdb-popover-text' href='https://docs.paybee.io/home/campaigns/ticketing/understanding-ticketing-on-paybee#combination-tickets' target='_blank'>Learn more</a>" 

  constructor(
    @Inject(PARTY_SIGNUP_ACCORDION_SETTINGS_TOKEN) public accordion: any,
    private store: Store,
    private fb: UntypedFormBuilder,
    private campaignService: CampaignService,
    private campaignFormService: CampaignFormService,
    public campaignOptionFormService: CampaignOptionFormService,
    private imageService: ImageService,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private toastService: ToastService,
    private chooseImageModalService: ChooseImageModalService,
    public accordionService: AccordionService,
  ) { 
    this.accordionService.map = {
      ...this.accordionService.map,
      ...this.accordion,
    };
  }

  ngOnInit(): void {
    const { selected } = this;

    this.campaign$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(campaign => {
      this.campaign = campaign;
    });

    if(this.selected) {
      const imageUrls = selected.get('imageUrls').value;
      this.optionImages = imageUrls;
      this.toggleChooseImageModal()

      this.setImageValueByType(selected, 'thumbnail')

      this.option = this.selected;
      this.value = _.cloneDeep(this.selected.value);
    } else {
      this.option = this.fb.group({});
      this.campaignService.generateForm(this.option, PartySignUpPresetOptionSchema);
    }

    this.reNgOnInit();
  }

  ngAfterViewInit(): void {
    window['$']('[data-toggle="tooltip"]').tooltip(
      {
        placement: 'left',
        trigger: 'click',
        html: true,
        template: '<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' 
    }
    )
  }

  reNgOnInit() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
    
    this.takeUntilSubject = new Subject();

    const inventory = this.option.get('inventory');
    const hideInventory = this.option.get('hideInventory');

    this.optionImages = this.option.get('imageUrls').value;
    // this.setImageSubscriptions('image');
    this.setImageSubscriptions('thumbnail');

    this.option.get('amount').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      const amount = this.option.get('amount');
      amount.clearValidators();
      const validators = [Validators.required, Validators.max(400000)]
      validators.push(Validators.min(value === 0 ? 0: 1));
      amount.setValidators(validators);
      amount.updateValueAndValidity({ emitEvent: false });
    });

    this.option.get('minQuantity').valueChanges.pipe(
      map(value => { return parseInt(value) || 0; }),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const allowedQuantity = this.option.get('allowedQuantity');
      allowedQuantity.clearValidators();
      value > 0 ?
        allowedQuantity.setValidators([Validators.required, Validators.min(value > 1000 ? 1000: value), Validators.max(1000)]):
        allowedQuantity.setValidators([Validators.required, Validators.min(1), Validators.max(1000)]);
      allowedQuantity.updateValueAndValidity({ emitEvent: false });
    });

    this.option.get('allowedQuantity').valueChanges.pipe(
      map(value => { return parseInt(value) || 0; }),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const minQuantity = this.option.get('minQuantity');
      minQuantity.clearValidators();
      value > 0 ?
        minQuantity.setValidators([Validators.required, Validators.min(1), Validators.max(value > 1000 ? 1000: value)]):
        minQuantity.setValidators([Validators.required, Validators.min(1), Validators.max(1000)]);
      minQuantity.updateValueAndValidity({ emitEvent: false });
    });

    this.option.get('enforceInventory').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      const validators = value ? [Validators.min(1)]: [Validators.min(0), Validators.max(0)];
      inventory.clearValidators();
      inventory.setValidators(validators);
    });

    this.option.get('enforceInventory').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value) => {
      inventory.setValue(value ? this.sold: 0);
      hideInventory.setValidators(value ? []: [Validators.requiredTrue]);
      hideInventory.setValue(!value);
      hideInventory.updateValueAndValidity({ emitEvent: false });
    });

    this.option.get('inventory').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const enforceInventory = this.option.get("enforceInventory").value;
      if(value < this.sold && enforceInventory){
        this.option.get('inventory').setErrors({'incorrect': true});
        this.isTolalInventoryValid = false;
      } else{
        this.option.get('inventory').setErrors(null);
        this.isTolalInventoryValid = true;
      }
    });

    this.option.get('sendTicket').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      this.option.get('noQrCodeInEmail').setValue(false);
    });

    this.option.get('hostName').valueChanges.pipe(
      map(value => value === null ? "": value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      this.hostNameEmpty = value.length > 0 ? false: true;
      this.hostIsValid = !this.hostNameEmpty && !this.hostEmailEmpty;

      if(this.hostIsValid) {
        this.option.get('notifyHost').enable();
        this.option.get('displayHostInfo').enable();
      } else {
        this.option.get('notifyHost').setValue(false);
        this.option.get('displayHostInfo').setValue(false);

        this.option.get('notifyHost').disable();
        this.option.get('displayHostInfo').disable();
      }
    });

    this.option.get('hostEmail').valueChanges.pipe(
      map(value => value === null ? "": value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      this.hostEmailEmpty = value.length > 0 ? false: true;
      this.hostIsValid = !this.hostNameEmpty && !this.hostEmailEmpty;

      if(this.hostIsValid) {
        this.option.get('notifyHost').enable();
        this.option.get('displayHostInfo').enable();
      } else {
        this.option.get('notifyHost').setValue(false);
        this.option.get('displayHostInfo').setValue(false);

        this.option.get('notifyHost').disable();
        this.option.get('displayHostInfo').disable();
      }
    });

    const optionStartDate = this.option.get("optionStartDate");
    const optionEndDate = this.option.get("optionEndDate");

    optionStartDate.valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      optionEndDate.updateValueAndValidity();
    });

    optionEndDate.setValidators([function(control: AbstractControl) {
      const optionEndDateValue = control.value ? control.value: 0;
      const optionStartDateValue = optionStartDate.value ? optionStartDate.value: 0;
      if(optionEndDateValue === 0) {
        return null;
      }
      return optionStartDateValue > optionEndDateValue ? { incorrectDate: { value: optionEndDateValue } } : null;
    }]);

    this.hostNameEmpty = this.option.get('hostName').value.length > 0 ? false: true;
    this.hostEmailEmpty = this.option.get('hostEmail').value.length > 0 ? false: true;
    this.hostIsValid = !this.hostNameEmpty && !this.hostEmailEmpty;

    if(this.hostIsValid) {
      this.option.get('notifyHost').enable();
      this.option.get('displayHostInfo').enable();
    } else {
      this.option.get('notifyHost').setValue(false);
      this.option.get('displayHostInfo').setValue(false);

      this.option.get('notifyHost').disable();
      this.option.get('displayHostInfo').disable();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const selected = _.get(changes, 'selected.currentValue', this.selected);
    if(selected) {
      this.setImageValueByType(selected, 'thumbnail')

      this.option = this.selected;
      this.value = _.cloneDeep(this.selected.value);
    }

    if(this.option) {
      this.reNgOnInit();
    }
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
    this.campaignOptionFormService.submitted = false;

    Object.keys(this.accordion).forEach((key) => {
      delete this.accordionService.map[key];
    });
  }

  onCancel() {
    if(this.selected) {
      this.option.reset(this.value);
    }
    this.onChangeData.next(false);
  }

  saveCampaignOption() {
    const { campaign, option, selected } = this;

    const name = option.get('name');
    const trimedName = _.trim(name.value);
    name.setValue(trimedName);

    if(option.invalid) {
      option.markAllAsTouched();
      this.campaignFormService.isNotValid();
      this.campaignOptionFormService.submitted = true;
      return false;
    }

    option.get("eventVenue").get("stringAddress").setValue("");

    const enforceInventory = this.option.get('enforceInventory');
    if(enforceInventory.value === false) {
      this.option.get('inventory').setValue(0);
    }

    if(selected) {      
      const thumbnailUrl = selected.get('thumbnailUrl').value === '/images/blank_1x1.png' ?
        '':
        selected.get('thumbnailUrl').value;
      selected.get('thumbnailUrl').setValue(thumbnailUrl);
   
      const optionValue = this.campaignService.generateRequestObject(selected, PartySignUpPresetOptionSchema);
  
      this.store.dispatch({
        type: newUpdateCampaignPresetOption.type,
        payload: { campaign, option: optionValue }
      });
      return this.onCancel();
    } else {
      this.addCampaignOption();
    }
  }

  addCampaignOption() {
    const { campaign, option, option: { value } } = this;

    const thumbnailUrl = value.thumbnailUrl === '/images/blank_1x1.png' ? '' : value.thumbnailUrl;
    option.get('thumbnailUrl').setValue(thumbnailUrl);
    
    const group = this.fb.group({});
    this.campaignService.generateForm(group, PartySignUpPresetOptionSchema);
    this.campaignService.initializeForm(group, this.option.value, PartySignUpPresetOptionSchema);

    option.reset();
    option.get('thumbnailUrl').setValue("/images/blank_1x1.png");

    const campaignId = _.get(campaign, 'id', null);
    const optionId = _.get(option, 'value.id', null);
    const optionValue: any = this.campaignService.generateRequestObject(group, PartySignUpPresetOptionSchema);
    optionValue.imageUrls = this.optionImages;

    if(_.isNull(campaignId)) {
      this.store.dispatch({
        type: newAddCampaignPresetOption.type,
        payload: { option: optionValue }
      });
      return this.onChangeData.next(true);
    }

    if(_.isNull(optionId)) {
      this.store.dispatch({
        type: newCreateCampaignPresetOption.type,
        payload: { campaign, option: optionValue }
      });
      return this.onCancel();
    }

    this.store.dispatch({
      type: newUpdateCampaignPresetOption.type,
      payload: { campaign, option: optionValue }
    });
    return this.onCancel();
  }

  uploadImages(id = 'option-images') {
    if (!this.imagesQueue.length) {
      return;
    }

    this.imageService.cropper({
      id,
      images: this.imagesQueue
    });
  }

  onRemoveImage(index) {
    this.optionImages = _.filter(this.optionImages, (image, imageIndex) => imageIndex !== index);
    this.option.get('imageUrls').setValue(this.optionImages);

    this.toggleChooseImageModal()
  }

  toggleChooseImageModal() {
    if(this.optionImages.length !== 0 ) {
      this.chooseImageModalShow = false;
      window['$']('[data-toggle="tooltip"]').tooltip({
        placement: 'left',
        trigger: 'click',
        html: true,
        template: '<div class="tooltip custom-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' 
      })
    } else {
      this.chooseImageModalShow = true;
    }
  }

  setImageSubscriptions(type = 'image') {
    const ratio = type === 'image' ? 2/1 : 1/1;

    this.option.get('imageUrlsFile').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const id = 'option-images';
      if (value && value.length) {
        this.imagesQueue = value;
        this.uploadImages(id);

      } else {
        this.openCropperModal(value, id);
      }
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === 'option-images'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      this.cdr.markForCheck();
    });

    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === 'option-images'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      if (result === false) {
        const control = this.option.get('imageUrlsData');
        const filtered = _.filter(control.value, (image, index) => {
          return index < control.value.length - 1;
        });
        control.setValue([...filtered]);
        this.optionImages = [...this.optionImages, ...filtered];
        this.toggleChooseImageModal()
      } else {
        if (result.imageUrl) {
          this.optionImages.push(result.imageUrl);
          this.toggleChooseImageModal()
        }
      }

      this.cdr.markForCheck();
    });

    this.option.get(`${type}File`).valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      if(value == 'size error'){
        this.toastService.showDanger('The picture must be at least 200px by 200px.', {delay: 3000});
      }else{
        this.openCropperModal(value, `option-${type}`, ratio)
      } 
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === `option-${type}`),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      this.option.get(`${type}DataUrl`).setValue(result);
    });
    
    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === `option-${type}`),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      if(result === false) {
        this.resetImageByType(`${type}`);
      } else {
        this.option.get(`${type}Url`).setValue(result.imageUrl);
      }
      this.cdr.markForCheck();
    });
  }

  onDrop(event: MdbDropEvent) {
    moveItemsInContainer(this.optionImages, event.previousIndex, event.newIndex);
  }

  openCropperModal(value, id, aspectRatio = 2/1) {
    const windowURL = window.URL || window.webkitURL;
    const url = windowURL.createObjectURL(value);
    this.imageService.cropper({
      url: this.domSanitizer.bypassSecurityTrustUrl(url),
      id: id,
      name: value.name,
      type: value.type,
      aspectRatio
    });
  }

  setImageValueByType(selected, type = 'image') {
    const ratio = type === 'image' ? '2x1' : '1x1';
    const url = selected.get(`${type}Url`).value === '/images/org_logo_default_v2.svg' ?
      `/images/blank_${ratio}.png`:
      selected.get(`${type}Url`).value;

    selected.get(`${type}DataUrl`).setValue(url);
    selected.get(`${type}Url`).setValue(url);
  }

  resetImageByType(type = 'image') {
    const ratio = type === 'image' ? '2x1' : '1x1';
    this.option.get(`${type}File`).setValue(null);
    this.option.get(`${type}DataUrl`).setValue(`/images/blank_${ratio}.png`);
    this.option.get(`${type}Url`).setValue(`/images/blank_${ratio}.png`);
  }

  onClickLearnMore() {
    const action = DialogActions.openDialog({
      payload: {
        name: "learnMore",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
      }
    });
    this.store.dispatch(action);
  }

  getInventoryErrorState() {
    const { option } = this;
    const inventory = option.get('inventory');

    if(!inventory.touched) return '';

    if(inventory.hasError('min')) {
      return true;
    }

    return false;
  }

  getSold(){
    let inventory = this.option.get('inventory').value
    let hideInventory = this.option.get("hideInventory").value
    if(hideInventory){
      if(this.sold){
        return  `${this.sold} Sold.` 
      }else{
        return 'None sold yet.'
      }
    } else {  
        if(this.sold){
          return  `${this.sold} of ${inventory} sold.` 
        } else{
          return 'None sold yet.'
        }
    }
  }

  openChooseImageModal(type = 0) { // 0 for 2x1, 1 for 1x1
    const params = {
      start: 0,
      returnCount: 40,
      filterBy: [type]
    }

    this.campaignService.getOrganizationImages(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((imageList: any)=> {
      const list = imageList || [];
      const images = list.filter((image) => image.type === type)
      const modalRef = this.chooseImageModalService.open({ images, type, multiple: type === 0 });
    
      modalRef.onClose.pipe(
        takeUntil(this.takeUntilSubject)
      ).subscribe((imageUrl) =>{
        this.chooseImageModalService.modalRef = null;
        const control = type === 0 ? 'image' : 'thumbnail';

        if(!imageUrl) {
          return;
        }

        if(control == 'image') {
          if (Array.isArray(imageUrl)) {
            this.optionImages.push(...imageUrl);
          } else {
            this.optionImages.push(imageUrl);
          }
          this.option.get('imageUrls').setValue(this.optionImages);

        } else {
          this.option.get(`${control}DataUrl`).setValue(imageUrl);
          this.option.get(`${control}Url`).setValue(imageUrl);
        }

        this.toggleChooseImageModal();
        this.toastService.show('success', 'Added Successfully!', {delay: 2000});
      })
    })
  }

  generateThumbnail() {
    const imageUrls = this.optionImages || [];
    const imgUrl = imageUrls.length > 0 ? imageUrls[0] : '';

    if(!imgUrl) {
      this.toastService.show('danger', 'Please upload an option image first.', {delay: 2500});
      return;
    }

    const params = {
      imageURL: imgUrl,
      width: 200
    }

    this.campaignService.generateThumbnail(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((response: any)=> {
      const url = response.thumbnailURL || '/images/blank_1x1.png';

      this.option.get('thumbnailDataUrl').setValue(url);
      this.option.get('thumbnailUrl').setValue(url);
      this.toastService.show('success', 'Generated Successfully!', {delay: 2000});
    })
  }

  generateSummary(summarySize = 0) {
    const description = this.option.get('desc').value || '';
    const summarySizeList = ['oneSentence', 'short', 'medium', 'long']

    if(description === "") {
      this.toastService.show('danger', 'Please add an option description first.', {delay: 2500});
      return;
    }

    const params = {
      text: description,
      summarySize: summarySizeList[summarySize]
    }

    this.campaignService.generateCSummary(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((response: any)=> {
      this.option.get('summary').setValue(response.summary);
      this.toastService.show('success', 'Generated Successfully!', {delay: 2000});
    })
  }
}
